/**
 * Checks if a given port is in a list of ports or port ranges.
 *
 * @param {string} p - The port to check.
 * @param {string} portList - A comma-separated list of ports or port ranges (e.g., "80, 443, 1000-2000").
 * @returns {boolean} - Returns `true` if the port is in the list or range, otherwise `false`.
 */
export const isPortInPortList = (p: string, portList: string) => {
  if (!portList.includes('-')) return portList.includes(p);

  return portList.split(/,\s?/).some((portItem) => {
    if (!portItem.includes('-')) return portItem.includes(p);

    const port = Number(p);
    if (isNaN(port)) return false;

    const [start, end] = portItem.split(/\s?-\s?/).map(Number);
    return port >= start && port <= end;
  });
};
